import React from 'react';
import PropTypes from 'prop-types';
import { decodeString,
    twoDecimal,
    getProductBackground,
    hexToRGB } from '../../../utils/helper';
import ProductRatingCard from '../ProductRatingCard';
import ChevronRight from '../../../assets/images/products/chevron-right.svg';

function ProductSummaryListItem({header,
    isPublic,
    handleClick}) {
    const { header_type,
        header_id,
        ratingUnavailable,
        meta } = header,
        headerTitle = decodeString(header_type).toLowerCase(),
        showRating = !!meta,
        ratingToShow = showRating
            ? twoDecimal(meta.overall_rating)
            : 0,
        maxRating = showRating
            ? meta.max_rating
            : 0,
        backgroundColor = showRating
            ? meta.color_code
            : '',
        ratingCount = showRating
            ? meta.count
            : 0,
        rgbColor = !!backgroundColor ? hexToRGB(backgroundColor, 0.2) : '',
        listBackground = getProductBackground(rgbColor),
        subTitle = decodeString(header.subTitle),
        listItemClassName = `product__reports__list__item
            ${!!ratingUnavailable ? 'product__reports__list__item--empty' : ''}
            ${isPublic ? 'cursor-pointer' : ''}`,
        productRatingClassName = `product__ratings__default product__ratings__default--medium ${!!ratingUnavailable ? 'product__ratings__default--empty' : ''}`
    if (ratingUnavailable) return (<li onClick={handleClick} className={listItemClassName}>
        <ProductRatingCard maxRating={maxRating}
            containerClass={productRatingClassName}
            ratingUnavailable={true} />
        <div>
            <p className="product__reports__list__title">{headerTitle}</p>
            { (!!subTitle || isPublic) && <p className="product__reports__list__sub-title">{isPublic
                ? 'Login to view'
                : subTitle}</p>}
        </div>
    </li>);
    return (<li onClick={() => handleClick(header_id)} style={{background: listBackground}} className={listItemClassName}>
        <ProductRatingCard ratingToShow={ratingToShow}
            maxRating={maxRating}
            containerClass={productRatingClassName}
            backgroundColor={backgroundColor}  />
        <div>
        <p className="product__reports__list__title">{headerTitle}</p>
        { !!subTitle && <p className="product__reports__list__sub-title">{subTitle}</p>}
        <img className="product__reports__list__icon" src={ChevronRight} alt="open" />
        </div>
    </li>)
};

ProductSummaryListItem.propTypes = {
    header: PropTypes.object.isRequired,
    handleClick: PropTypes.func.isRequired
}

export default ProductSummaryListItem;